/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "80e775e8aaf0456480d9065417a7283da539f679";
